import { render, staticRenderFns } from "./BusinessMemberDocumentUpload.vue?vue&type=template&id=959364b6"
import script from "./BusinessMemberDocumentUpload.vue?vue&type=script&lang=js"
export * from "./BusinessMemberDocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports